<template>
<zm-dialog v-model="visible" class="comparison-dialog comparison-dialog--zone-basic-plus" show-close @close="handleCancel">
  <template #header>
  <h1 class="comparison-dialog__title">{{ $t('marketing.new_pricing.full_plan') }}</h1>
  </template>
  <FullComparisonTable :treeData="treeData" :colConfig="colConfig" :value="this.currentBasicPlusCategory" :width="750"/>
</zm-dialog>
</template>
<script>

import { ZoomMeetingComparisonDataMixins } from '@/components/full-comparison-table/comparison-data-mixins';
import FullComparisonTable from '@/components/full-comparison-table/full-comparison-table.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
import { get } from 'lodash';

export default {
  components: {
    FullComparisonTable,
  },
  mixins: [ZoomMeetingComparisonDataMixins, ConfirmComponent],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    currentBasicPlusPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZONE_BASIC_PLUS);
    },
    currentBasicPlusCategory() {
      return get(this.currentBasicPlusPlan || {}, 'category', 'zobasicp');
    },
    colConfig() {
      return [
        {
          title: this.$t('one.lite'),
          key: this.currentBasicPlusCategory,
          category: this.currentBasicPlusCategory,
          btn: null,
        },
        {
          title: this.$t('common.pro'),
          key: 'pro',
          category: 'pro',
          btn: null,
        },
      ];
    },
  }
}
</script>
<style lang="scss">
.comparison-dialog {
  &--zone-basic-plus {
    &.zbo-dialog {
      max-width: 1015px;
      width: auto;
    }
  }
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 120%;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }
}
</style>
